import { render } from "./AppTableAccordion.vue?vue&type=template&id=3dac90de"
import script from "./AppTableAccordion.vue?vue&type=script&lang=js"
export * from "./AppTableAccordion.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__